import { ShortTaxMessage } from '@vp/swan';
import { __ } from '@99designs/i18n';
import useVatMessaging from '../../hooks/useVatMessaging';

interface VATMessageProps {
    /**
     * Whether the wording is the "bottom bar" version which has slightly different wording.
     */
    bottomBarVersion?: boolean;
}

export default function VATMessage({ bottomBarVersion }: VATMessageProps): React.ReactNode | null {
    const wording = useVatMessaging(bottomBarVersion);

    if (!wording) {
        return null;
    }

    return <ShortTaxMessage>{wording}</ShortTaxMessage>;
}
